import _isNil from "lodash/isNil";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es7.object.values.js";
import KitCategory, { isKitCategory } from 'const/enums/KitCategory';
import { getMatcherAreValid, getMatcherIsNeeded } from 'utils/secondary-analysis/fastqMatcher';
import FastqFileType from 'const/enums/FastqFileType';
import createMemoizedSelector from '../createMemoizedSelector';
import getPairs from './getPairs';
import getMergedSublibrarySelections from './getMergedSublibrarySelections';
var WT_FASTQ = FastqFileType.WT_FASTQ,
  IMMUNE_FASTQ = FastqFileType.IMMUNE_FASTQ;
var getFastqMatcherAreValidSelector = function getFastqMatcherAreValidSelector() {
  return function (analysisState, pairs, mergedSublibrarySelections) {
    var _files$data, _files$data2;
    if (_isNil(analysisState) || _isNil(pairs)) return false;
    var numOfSublibraries = analysisState.numOfSublibraries,
      pairedWt = analysisState.pairedWt,
      kit = analysisState.kit,
      files = analysisState.files;
    var wtRequired = isKitCategory(kit, [KitCategory.WT]) || pairedWt;
    var immuneRequired = isKitCategory(kit, [KitCategory.TCR, KitCategory.BCR]);
    var wtFileCount = Object.values((_files$data = files === null || files === void 0 ? void 0 : files.data) !== null && _files$data !== void 0 ? _files$data : {}).filter(function (file) {
      return file.type === WT_FASTQ;
    }).length;
    var immuneFileCount = Object.values((_files$data2 = files === null || files === void 0 ? void 0 : files.data) !== null && _files$data2 !== void 0 ? _files$data2 : {}).filter(function (file) {
      return file.type === IMMUNE_FASTQ;
    }).length;
    var matcherIsNeeded = getMatcherIsNeeded(pairedWt, wtFileCount, immuneFileCount, numOfSublibraries, pairs);
    return getMatcherAreValid({
      matcherIsNeeded: matcherIsNeeded,
      sublibrarySelections: mergedSublibrarySelections,
      pairs: pairs,
      numOfSublibraries: numOfSublibraries,
      wtRequired: wtRequired,
      immuneRequired: immuneRequired
    });
  };
};
export default createMemoizedSelector(getFastqMatcherAreValidSelector, {
  inputSelectors: [{
    func: function func(secondaryAnalysisId) {
      return function (state) {
        return state[secondaryAnalysisId];
      };
    },
    paramsIngest: function paramsIngest(secondaryAnalysisId) {
      return [secondaryAnalysisId];
    }
  }, {
    func: getPairs,
    paramsIngest: function paramsIngest(secondaryAnalysisId) {
      return [secondaryAnalysisId];
    }
  }, {
    func: getMergedSublibrarySelections,
    paramsIngest: function paramsIngest(secondaryAnalysisId) {
      return [secondaryAnalysisId];
    }
  }]
});